import React, { useState } from 'react';

import { Card, Dialog, DialogContent, Typography } from '@material-ui/core';

import API from 'utils/api';
import { useDialog, useSources } from 'hooks';
import { buildImageUrl, call, classes } from 'utils';
import { LeagueTeamFilter } from 'routes/Dashboard/SportsApi';
import { DialogActions, DialogTitle, Progress } from 'components';

import styles from './ImageSelectorDialog.module.scss';

const ImageSelectorDialog = ({ open, onClose, onChange }) => {
  const [{ selected, images }, setState] = useState({});
  const sources = useSources();

  const fetchImages = filter => {
    setState({});
    sources.cancelAll();

    const { leagueId, teamId: teamAId } = filter || {};

    API.getImageLibraryList({ leagueId, teamAId }, sources).then(({ data, canceled }) =>
      canceled ? null : setState({ images: Array.isArray(data) ? data : [] })
    );
  };

  const { isOpening } = useDialog(open, {
    onOpen: fetchImages,
    onClose: () => sources.cancelAll(),
  });

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle onClose={onClose}>Image Library</DialogTitle>

      <DialogContent className={styles.content}>
        <LeagueTeamFilter onChange={fetchImages} />

        <div className={styles.body}>
          {images && !isOpening ? (
            images.length ? (
              <div className={styles.list}>
                {images.map(it => (
                  <Card
                    key={it._id}
                    className={classes(
                      styles.card,
                      it === selected ? styles.selected : ''
                    )}
                    style={{ backgroundImage: buildImageUrl(it) }}
                    onClick={() => setState(state => ({ ...state, selected: it }))}
                  />
                ))}
              </div>
            ) : (
              <Typography variant="body1" style={{ margin: 'auto' }}>
                No images to display
              </Typography>
            )
          ) : (
            <Progress style={{ margin: 'auto' }} />
          )}
        </div>
      </DialogContent>

      <DialogActions
        actions={[
          { label: 'cancel', onClick: onClose },
          {
            label: 'select',
            onClick: () => call(onChange, selected),
            type: 'submit',
            disabled: !selected,
          },
        ]}
      />
    </Dialog>
  );
};

export default ImageSelectorDialog;
